import { Component, Input, OnInit } from '@angular/core';
import { highlightQueryTokens, iconOf, matchedHintHtmlOf, SearchEntityConfig } from '../../../../shared/constants/search-entities';

/**
 * Generic search result card driven entirely by the search entity registry
 * (title / snippet / meta / status extractors). Used for every entity type
 * that doesn't have a bespoke card (daily reports and issues keep theirs).
 */
@Component({
    selector: 'app-search-result-card',
    templateUrl: './search-result-card.component.html',
    styleUrls: ['./search-result-card.component.scss'],
    standalone: false
})
export class SearchResultCardComponent implements OnInit {
  @Input() result: any;
  @Input() config: SearchEntityConfig;

  icon: string;
  title: string;
  snippet: string;
  meta: string;
  status: string;
  matchedHintHtml: string;
  titleHtml: string;
  snippetHtml: string;

  ngOnInit() {
    this.icon = iconOf(this.config, this.result);
    this.title = this.config?.titleOf?.(this.result) || '';
    this.snippet = this.config?.snippetOf?.(this.result) || '';
    this.meta = this.config?.metaOf?.(this.result) || '';
    this.status = (this.config?.statusOf?.(this.result) || '').replace(/[-_]/g, ' ');
    this.matchedHintHtml = matchedHintHtmlOf(this.result);
    // Escaped + query tokens banded with the global .highlighted-value style.
    this.titleHtml = highlightQueryTokens(this.title, this.result?.searchQuery);
    this.snippetHtml = highlightQueryTokens(this.snippet, this.result?.searchQuery);
  }
}
